export enum ShareStatusEnum {
    Unshared = 0,
    Shared = 1,
    Published = 2
}
